import Vue from 'vue'
import Vuex from 'vuex'
import firebase from "firebase/app"
import api from './helpers/ApiHelper'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    jwt: '',
    authLoading: false,
  },
  mutations: {
    // chargement auth
    setAuthLoading(state, authLoading) {
      state.authLoading = authLoading
    },

    // set je JWT
    setJwt(state, jwt) {
      if (process.env.NODE_ENV === 'development') {
        console.log('jwt', jwt)
      }
      state.jwt = jwt
      api.setToken(jwt)
    }

  },
  actions: {


    // logout
    logout(context) {

      firebase.auth().signOut().then(() => {
        console.log('Signed Out');
        // retire le JWT
        context.commit('setJwt', null)
        api.resetToken()
      }, (error) => {
        console.error('Sign Out Error', error);
      })


    }


  }
})
